import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./Locales/en.json";
import mk from "./Locales/mk.json";
import sq from "./Locales/sq.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      mk: { translation: mk },
      sq: { translation: sq },
    },
    lng: localStorage.getItem("lang") || "en", // Default language is stored in localStorage
    fallbackLng: "en", // Default fallback language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
